import React from 'react';
import { FluentSvgIcon } from 'mini-fluent-svg-icons/lib/components/FluentSvgIcon';

const styles = require('./CommandBarButton.scss');
const classNames = require('classnames/bind').bind(styles);

interface CommandBarButtonProps {
    icon?: string;
    onClick: (evt?: React.MouseEvent) => void;
    label?: string;
    className?: string;
    iconClassName?: string;
    textClassName?: string;
    ariaHasPopup?: boolean;
    isDisabled?: boolean;
    ariaLabel?: string;
}

export const CommandBarButton = React.forwardRef(
    (
        {
            onClick,
            icon,
            label,
            className,
            iconClassName,
            textClassName,
            ariaHasPopup = false,
            isDisabled = false,
            ariaLabel = label,
        }: CommandBarButtonProps,
        ref?: React.RefObject<any>
    ) => (
        <div
            aria-haspopup={ariaHasPopup}
            className={classNames(styles.commandBarButton, className, {
                [styles.disabled]: isDisabled,
            })}
            /*
             * The !isDisabled logic is used in the onClick because when aria-disabled is used,
             * that button becomes clickable in accessibility mode although it is disabled.
             */
            onClick={!isDisabled && onClick}
            aria-label={ariaLabel}
            aria-disabled={isDisabled}
            role="button"
            ref={ref}
            tabIndex={0}>
            {icon && (
                <FluentSvgIcon
                    icon={icon}
                    iconContainerStyles={classNames(styles.icon, iconClassName)}
                />
            )}
            {label && (
                <div
                    className={classNames(
                        styles.label,
                        icon && styles.labelWithIcon,
                        textClassName
                    )}>
                    {label}
                </div>
            )}
        </div>
    )
);
